
export const IconCard = () => {
    return (
      <div className='IconCard'>
        <img src="https://www.oncf-voyages.ma/media/static/fr/images/cartes-paiement.png" alt="IconCard"/>
      </div>
    )
  }